// https://support.trustpilot.com/hc/en-us/articles/115011421468--Add-a-TrustBox-widget-to-a-single-page-application#add-a-trustbox-widget-with-a-react-application-1
export default function TrustLineComponent() {
    return (
        <div
            className="trustpilot-widget"
            data-locale="da-DK"
            data-template-id="5419b637fa0340045cd0c936"
            data-businessunit-id="5687a64a0000ff0005872010"
            data-style-height="20px"
            data-style-width="100%"
            data-theme="dark"
            data-font-family="Montserrat"
        >
            <span />
        </div>
    )
}
